import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FormField } from '../../components/shared/form';
import { LegalLinks } from '../../components/LegalLinks';
import { useLoginPageVM } from './useLoginPageVM';

export default function LoginPage() {
  const { register, formState, onSubmit } = useLoginPageVM();
  const { t } = useTranslation();

  return (
    <div className="mx-auto max-w-sm px-4 py-10 sm:py-16">
      <h1 className="text-2xl font-semibold mb-6">{t('login.title')}</h1>
      <form onSubmit={onSubmit} className="space-y-4">
        <FormField label={t('field.email')} error={formState.errors.email?.message}>
          <input type="email" autoComplete="email" {...register('email')} className="input" />
        </FormField>
        <FormField label={t('field.password')} error={formState.errors.password?.message}>
          <input
            type="password"
            autoComplete="current-password"
            {...register('password')}
            className="input"
          />
        </FormField>
        <button type="submit" disabled={formState.isSubmitting} className="btn-primary w-full">
          {formState.isSubmitting ? t('login.submitting') : t('action.signIn')}
        </button>
      </form>
      <p className="mt-6 text-sm text-muted-foreground">
        {t('login.noAccount')}{' '}
        <Link to="/register" className="text-primary hover:underline">
          {t('login.createOne')}
        </Link>
      </p>
      <LegalLinks />
    </div>
  );
}
